export default function getValidators() {
  return [
    // TODO: Implement datetime
    // {
    //   key: 'datetime',
    //   title: 'Date',
    //   fields: []
    // },
    {
      key: 'email',
      title: 'Email',
      description: 'Is field a valid email?',
      fields: [
        {
          key: 'message',
          title: 'Message',
          type: 'text',
          defaultValue: '^Field is not a valid email',
          setValueOnMount: true
        }
      ]
    },
    {
      key: 'equality',
      title: 'Equality',
      description: 'Is field equal to another field?',
      fields: [
        {
          key: 'attribute',
          title: 'Attribute',
          type: 'text',
          defaultValue: '',
          constraints: {
            presence: {
              allowEmpty: false,
              message: '^The attribute to validate against is required'
            }
          },
          setValueOnMount: true
        },
        {
          key: 'message',
          title: 'Message',
          type: 'text',
          defaultValue: '^Field is not equal to "%{attribute}" field',
          setValueOnMount: true
        }
      ]
    },
    // TODO: Implement exclusion
    // {
    //   key: 'exclusion',
    //   title: 'Exclusion',
    //   description: 'Make sure field is not in the given list',
    //   fields: [
    //     {
    //       key: 'within',
    //       title: 'Within',
    //       type: 'text', // FIXME: This needs to either be an array or object with keys as the values to check
    //       defaultValue: '',
    //       setValueOnMount: true
    //     },
    //     {
    //       key: 'message',
    //       title: 'Message',
    //       type: 'text',
    //       defaultValue: '^%{value} is not allowed',
    //       setValueOnMount: true
    //     }
    //   ]
    // },
    {
      key: 'format',
      title: 'Pattern (Regex)',
      description: 'Does field match the given pattern?',
      fields: [
        {
          key: 'pattern',
          title: 'Pattern',
          type: 'text',
          defaultValue: '',
          setValueOnMount: true
        },
        {
          key: 'flags',
          title: 'Flags',
          type: 'text',
          defaultValue: '',
          setValueOnMount: true
        },
        {
          key: 'message',
          title: 'Message',
          type: 'text',
          defaultValue: 'is invalid',
          setValueOnMount: true
        }
      ]
    },
    // TODO: Implement inclusion
    // {
    //   key: 'inclusion',
    //   title: 'Inclusion',
    //   description: 'Make sure field is one of the given list',
    //   fields: [
    //     {
    //       key: 'within',
    //       title: 'Within',
    //       type: 'text', // FIXME: This needs to either be an array or object with keys as the values to check
    //       defaultValue: ''
    //     },
    //     {
    //       key: 'message',
    //       title: 'Message',
    //       type: 'text',
    //       defaultValue: '^%{value} is not allowed'
    //     }
    //   ]
    // },
    {
      key: 'length',
      title: 'Length',
      description: 'Checks the length of a string',
      fields: [
        {
          key: 'is',
          title: 'Is',
          type: 'number',
          defaultValue: '',
          setValueOnMount: true
        },
        {
          key: 'wrongLength',
          title: 'Wrong Length Message',
          type: 'text',
          defaultValue: 'is the wrong length (should be %{count} characters)',
          setValueOnMount: true
        },
        {
          key: 'minimum',
          title: 'Minimum',
          type: 'number',
          defaultValue: '',
          setValueOnMount: true
        },
        {
          key: 'tooShort',
          title: 'Too Short Message',
          type: 'text',
          defaultValue: 'is too short (minimum is %{count} characters)',
          setValueOnMount: true
        },
        {
          key: 'maximum',
          title: 'Maximum',
          type: 'number',
          defaultValue: '',
          setValueOnMount: true
        },
        {
          key: 'tooLong',
          title: 'Too Long Message',
          type: 'text',
          defaultValue: 'is too long (maximum is %{count} characters)',
          setValueOnMount: true
        }
      ]
    },
    {
      key: 'numericality',
      title: 'Numerical',
      description: 'Number checking',
      fields: [
        {
          key: 'onlyInteger',
          title: 'Only Integer',
          type: 'boolean',
          defaultValue: false,
          setValueOnMount: true
        },
        {
          key: 'strict',
          title: 'Strict',
          type: 'boolean',
          defaultValue: false,
          setValueOnMount: true
        },
        {
          key: 'greaterThan',
          title: 'Greater Than',
          type: 'number',
          setValueOnMount: true
        },
        {
          key: 'greaterThanOrEqualTo',
          title: 'Greater Than Or Equal To',
          type: 'number',
          setValueOnMount: true
        },
        {
          key: 'equalTo',
          title: 'Equal To',
          type: 'number',
          setValueOnMount: true
        },
        {
          key: 'lessThanOrEqualTo',
          title: 'Less Than Or Equal To',
          type: 'number',
          setValueOnMount: true
        },
        {
          key: 'lessThan',
          title: 'Less Than',
          type: 'number',
          setValueOnMount: true
        },
        {
          key: 'divisibleBy',
          title: 'Divisible By',
          type: 'number',
          setValueOnMount: true
        },
        {
          key: 'odd',
          title: 'Is Odd',
          type: 'boolean',
          defaultValue: false,
          setValueOnMount: true
        },
        {
          key: 'even',
          title: 'Is Even',
          type: 'boolean',
          defaultValue: false,
          setValueOnMount: true
        },
        {
          key: 'notValid',
          title: 'Not Valid Message',
          type: 'text',
          defaultValue: 'is not a valid number',
          setValueOnMount: true
        },
        {
          key: 'notInteger',
          title: 'Not Integer Message',
          type: 'text',
          defaultValue: 'must be an integer',
          setValueOnMount: true
        },
        {
          key: 'notGreaterThan',
          title: 'Not Greater Than Message',
          type: 'text',
          defaultValue: 'must be greater than %{count}',
          setValueOnMount: true
        },
        {
          key: 'notGreaterThanOrEqualTo',
          title: 'Not Greater Than Or Equal To Message',
          type: 'text',
          defaultValue: 'must be greater than or equal to %{count}',
          setValueOnMount: true
        },
        {
          key: 'notEqualTo',
          title: 'Not Equal To Message',
          type: 'text',
          defaultValue: 'must be equal to %{count}',
          setValueOnMount: true
        },
        {
          key: 'notLessThan',
          title: 'Not Less Than Message',
          type: 'text',
          defaultValue: 'must be less than %{count}',
          setValueOnMount: true
        },
        {
          key: 'notLessThanOrEqualTo',
          title: 'Not Less Than Or Equal To Message',
          type: 'text',
          defaultValue: 'must be less than or equal to %{count}',
          setValueOnMount: true
        },
        {
          key: 'notDivisibleBy',
          title: 'Not Divisible By Message',
          type: 'text',
          defaultValue: 'must be divisible by %{count}',
          setValueOnMount: true
        },
        {
          key: 'notOdd',
          title: 'Not Odd Message',
          type: 'text',
          defaultValue: 'must be odd',
          setValueOnMount: true
        },
        {
          key: 'notEven',
          title: 'Not Even Message',
          type: 'text',
          defaultValue: 'must be even',
          setValueOnMount: true
        }
      ]
    },
    {
      key: 'presence',
      title: 'Required',
      description: 'Is field required?',
      fields: [
        {
          key: 'message',
          title: 'Message',
          type: 'text',
          defaultValue: '^Field is required',
          setValueOnMount: true
        },
        {
          key: 'allowEmpty',
          title: 'Allow Empty',
          type: 'boolean',
          defaultValue: true,
          setValueOnMount: true
        }
      ]
    },
    {
      key: 'url',
      title: 'URL',
      description: 'Is a valid URL?',
      fields: [
        {
          key: 'message',
          title: 'Message',
          type: 'text',
          defaultValue: '^Field is not a valid url',
          setValueOnMount: true
        },
        {
          key: 'schemes',
          title: 'Schemes',
          type: 'text', // FIXME: Needs to be an array
          defaultValue: [ 'http', 'https' ],
          setValueOnMount: true
        },
        {
          key: 'allowLocal',
          title: 'Allow Local',
          type: 'boolean',
          defaultValue: false,
          setValueOnMount: true
        }
      ]
    }
  ];
}
